import { IconPropTypes } from '@/legacy/types';

const DoorOpen = (props: IconPropTypes) => {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width={props.width || 16}
			height={props.height || 16}
			fill='none'
			{...props}
		>
			<g
				stroke={props.color || 'currentColor'}
				strokeLinecap='round'
				strokeLinejoin='round'
				strokeWidth={1.143}
				clipPath='url(#a)'
			>
				<path d='M8.5 8H15M12.5 5.5 15 8l-2.5 2.5M2.111 15H4.89C5.503 15 6 14.518 6 13.923V2.077C6 1.482 5.503 1 4.889 1H2.11C1.497 1 1 1.482 1 2.077v11.846C1 14.518 1.497 15 2.111 15Z' />
			</g>
			<defs>
				<clipPath id='a'>
					<path
						fill='#fff'
						d='M0 0h16v16H0z'
					/>
				</clipPath>
			</defs>
		</svg>
	);
};

export default DoorOpen;
